var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateGoldenmetrics',{attrs:{"title":_vm.$t('menu.orders'),"categories":_vm.categories,"route":_vm.$listRoutes.dashboardOrders}})
}
var staticRenderFns = []

export { render, staticRenderFns }